<!-- <app-card-header [header]="header"></app-card-header> -->

<div class="container">
    <mat-card class="mat-elevation-z8 w-100">
        <div class="row card-border pt-2 pb-2">
            <div class="col-8">
                <h2>Fórmulas cadastradas</h2>
            </div>
            <div class="col-4 text-right">
                <button mat-flat-button color="primary" (click)="goToSave()" matTooltip="Nova Fórmula"
                    skipLocationChange>
                    <i class="fa fa-plus fa-1x btnIcon"></i> Nova Fórmula
                </button>
                <!-- <button mat-flat-button color="primary" (click)="makeSync()" class="ml-2" matTooltip="Sincronizar" [disabled]="!statusClient">
                    <i class="fa fa-refresh fa-1x btnIcon"></i>
                    Sincronizar
                </button> -->
            </div>
            <div class="col-12 mt-3" [formGroup]="formFilter" *ngIf="statusClient">
                <mat-form-field class="w-100">
                    <input matInput placeholder="Pesquisa por nome" formControlName="search" (keydown.enter)="getList()">
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-2">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort class="w-100">

                    <ng-container matColumnDef="created_at">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="created_at"
                            class="InputLabelHeaderColor formatField"> Data de Cadastro
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> {{row.created_at | date:'dd/MM/yyyy'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="name"
                            class="InputLabelHeaderColor formatField"> Nome
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField" matTooltip="{{row.name}}"> {{row.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="description"
                            class="InputLabelHeaderColor formatField"> Descrição
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField" matTooltip="{{row.description}}"> {{row.description}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="status"
                            class="InputLabelHeaderColor formatField"> Status
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField"> 
                                <button mat-flat-button color="{{row.active ? 'primary': 'link'}}"
                                    matTooltip="{{row.active ? 'Desativar Fórmula': 'Ativar Fórmula'}}" (click)="goToStatus(row)"
                                    skipLocationChange>
                                    <i class="fa fa-toggle-off fa-1x btnIcon" *ngIf="!row.active"></i>
                                    <i class="fa fa-toggle-on fa-1x btnIcon" *ngIf="row.active"></i>
                                    {{row.active ? 'Ativado': 'Desativado'}}
                                </button>
                            <!-- <mat-slide-toggle class="example-margin" [checked]="row.active" [disabled]="true"
                            matTooltip="{{row.active ? 'Fórmula ativada': 'Fórmula desativada'}}"></mat-slide-toggle>                            -->
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="#">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="InputLabelHeaderColor formatField">
                            Ações
                        </th>
                        <td mat-cell *matCellDef="let row" class="formatField">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-button color="primary" class="mr-1 mt-2 ml-1"
                                    matTooltip="Editar Registro" (click)="goToEdit(row)">
                                    <i class="fa fa-edit fa-1x btnIcon"></i>
                                    Editar
                                </button>
                                <button mat-button color="warn" class="mr-1 mt-2 ml-1"
                                    matTooltip="Excluir Registro" (click)="goToDelete(row)">
                                    <i class="fa fa-remove fa-1x btnIcon"></i>
                                    Excluir
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" colspan="100%"><i
                                class="fa fa-exclamation-triangle iconWarning" aria-hidden="true"></i> Nenhum registro
                            encontrado</td>
                    </tr>

                </table>
                <mat-paginator [pageSizeOptions]="pageSizeOptions"></mat-paginator>
            </div>
        </div>
    </mat-card>
</div>